export default "__VITE_ASSET__CQB5QUBJ__"